import { authApiService } from '../../authApiService';
import { ApiParams } from '../../helpers/apiHelpers';
import { ApiResponseType } from '@/types/sharedTypes';
import { AssignedWireType } from '@/types/wireTypes';
import { WIRE_STATUS_DB } from '@/const/wire';

export type ChangeStatusDataType = {
  status: typeof WIRE_STATUS_DB.EXECUTED;
};

export const executorChangeWireStatusApi = async (
  id: string,
  data: ChangeStatusDataType,
  params?: ApiParams
): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/executor/wires/${id}/status/`;

  return authApiService.PATCH(uri, data, params);
};
